import { useAppDispatch } from "../../../../redux/hooks";
import Text from "../../../../styleguide/Text";
import ActionMenu from "../../../../components/actionMenu/ActionMenu";

import {
  fetchDeliverySheets,
  generateDeliverySheets,
} from "../../../../redux/api/expedition.api";

import {
  checkEndpointStatus,
  endpointStatus,
} from "../../../../helpers/apiHelper";

import useTableCtx from "../../../../components/tables/tableContext/useTableCtx";
import { dateForDatabase } from "../../../../utils/dateAndTime";

function DeliverySheetsTableHeader() {
  const dispatch = useAppDispatch();

  const { tablePagination, tableSearch } = useTableCtx() || {};

  const handleGenerateDeliverySheetsAction = async () => {
    const resultAction = await dispatch(generateDeliverySheets());

    if (
      checkEndpointStatus(resultAction, generateDeliverySheets) ===
      endpointStatus.fulfilled
    ) {
      dispatch(
        fetchDeliverySheets({
          page: tablePagination?.page,
          perPage: tablePagination?.rowsPerPage,
          nod: tableSearch?.nodNume,
          ruta: tableSearch?.ruta,
          data_crearii: dateForDatabase(tableSearch?.data_crearii),
        }),
      );
    }
  };

  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <Text variant="h3" component="h3" className="!font-semibold">
        Borderouri de livrare
      </Text>

      <ActionMenu
        minItemsForMenu={2}
        ariaLabel="Actiuni borderouri de livrare"
        items={[
          {
            id: "generate-delivery-sheets",
            label: "Genereaza borderouri",
            tooltip:
              "Genereaza borderourile pentru expeditiile cu ridicare azi.",
            icon: "ADD",
            variant: "action",
            withConfirmationModal: {
              modalTitle: "Genereaza borderouri",
              modalSubtitle:
                "Esti sigur ca vrei sa generezi borderourile pentru ziua curenta?",
              modalLeftButtonText: "Anuleaza",
              modalLeftButtonVariant: "outlined",
              modalRightButtonText: "Genereaza",
              modalRightButtonOnClick: handleGenerateDeliverySheetsAction,
            },
          },
        ]}
      />
    </div>
  );
}

export default DeliverySheetsTableHeader;
